import { Sender } from 'xstate';

import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import { LogicContext } from '../types';

import config from '../../../config';
import { getGroupedCodesFromJPTiles } from '../../../utils/jackpotsV2/getGroupedCodesFromJPTiles';
import { getJackpotsForJPTiles } from '../../../utils/jackpotsV2/getJackpotsForJPTiles';
import { isEqualJackpotsData } from '../utils';

export const watchJackpots = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'JACKPOTS_UPDATED';
        data: {
          jackpotCode: string;
          multiJackpots: { [key: string]: any };
        };
      }>
    ) => {
      const intervalIds: Record<
        string,
        ReturnType<typeof setInterval> | undefined
      > = {
        section8: undefined,
        redtiger: undefined,
        blueprint: undefined,
      };

      const { controllersData } = context;
      if (!controllersData.categories) {
        return () => {};
      }
      const { components } = controllersData.categories;
      const jackpotTileGroupedCodes = getGroupedCodesFromJPTiles(components);
      const currency = context.user?.currency || config.default_currency;
      const section8Code = jackpotTileGroupedCodes.find(
        jackpotCode => jackpotCode[0] === 'section8'
      );

      if (section8Code && config.intervals.jackpots.multiple.section8) {
        intervalIds.section8 = setInterval(async () => {
          const data = await getJackpotsForJPTiles([section8Code], currency);
          if (
            !isEqualJackpotsData(
              context.multiJackpots[section8Code[0]],
              data[section8Code[0]]
            )
          ) {
            callback({
              type: 'JACKPOTS_UPDATED',
              data: {
                jackpotCode: section8Code[0],
                multiJackpots: data,
              },
            });
          }
        }, config.intervals.jackpots.multiple.section8);
      }

      const redtigerCode = jackpotTileGroupedCodes.find(
        jackpotCode => jackpotCode[0] === 'redtiger'
      );
      if (redtigerCode && config.intervals.jackpots.multiple.redtiger) {
        intervalIds.redtiger = setInterval(async () => {
          const data = await getJackpotsForJPTiles([redtigerCode], currency);
          if (
            !isEqualJackpotsData(
              context.multiJackpots[redtigerCode[0]],
              data[redtigerCode[0]]
            )
          ) {
            callback({
              type: 'JACKPOTS_UPDATED',
              data: {
                jackpotCode: redtigerCode[0],
                multiJackpots: data,
              },
            });
          }
        }, config.intervals.jackpots.multiple.redtiger);
      }

      const blueprintCode = jackpotTileGroupedCodes.find(
        jackpotCode => jackpotCode[0] === 'blueprint'
      );
      if (blueprintCode && config.intervals.jackpots.multiple.blueprint) {
        intervalIds.blueprint = setInterval(async () => {
          const data = await getJackpotsForJPTiles([blueprintCode], currency);
          if (
            !isEqualJackpotsData(
              context.multiJackpots[blueprintCode[0]],
              data[blueprintCode[0]]
            )
          ) {
            callback({
              type: 'JACKPOTS_UPDATED',
              data: {
                jackpotCode: blueprintCode[0],
                multiJackpots: data,
              },
            });
          }
        }, config.intervals.jackpots.multiple.blueprint);
      }

      return () => {
        Object.values(intervalIds).forEach(
          intervalId => intervalId && clearInterval(intervalId)
        );
      };
    }
  );
